var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.8335 4.66683H11.1668V3.3335C11.1668 2.00016 10.6668 1.3335 9.16683 1.3335H6.8335C5.3335 1.3335 4.8335 2.00016 4.8335 3.3335V4.66683Z",
    stroke: "#393945",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6668 10V12.6667C10.6668 14 10.0002 14.6667 8.66683 14.6667H7.3335C6.00016 14.6667 5.3335 14 5.3335 12.6667V10H10.6668Z",
    stroke: "#393945",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6.6665V9.99984C14 11.3332 13.3333 11.9998 12 11.9998H10.6667V9.99984H5.33333V11.9998H4C2.66667 11.9998 2 11.3332 2 9.99984V6.6665C2 5.33317 2.66667 4.6665 4 4.6665H12C13.3333 4.6665 14 5.33317 14 6.6665Z",
    stroke: "#393945",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3332 10H10.5265H4.6665",
    stroke: "#393945",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6665 7.3335H6.6665",
    stroke: "#393945",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintericon);
export default __webpack_public_path__ + "static/media/printericon.921b9a21.svg";
export { ForwardRef as ReactComponent };